import Message from "messaging/message";

export enum CreateMessageParam {
  contentPlainText = "contentPlainText",
  subject = "subject",
  attachments = "attachments",
  isAutoGenerated = "isAutoGenerated",
  publish = "publish"
}

export default class CreateMessageAPIRequest {
  public formData: FormData;

  public constructor(message: Message) {
    this.formData = new FormData();
    this.formData.append(
      CreateMessageParam.contentPlainText,
      message.content
    );
    this.formData.append(
      CreateMessageParam.subject,
      message.subject?.toString() ?? ""
    );
    this.formData.append(
      CreateMessageParam.isAutoGenerated,
      message.isAutoGenerated?.toString() ?? "false"
    );
    this.formData.append(
      CreateMessageParam.publish,
      message.isMarkedForPublish?.toString() ?? "false"
    )
    
    for (const attachment of message.attachments) {
      if (attachment.rawData === undefined) continue;
      this.formData.append(
        CreateMessageParam.attachments,
        attachment.rawData,
        attachment.name
      );
    }
  }
}
